import { memo, useMemo, useCallback, ReactNode, FC } from 'react';
import { SwiperProps, Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

interface CommonCarouselProps {
  items: any[];
  swiperProps: SwiperProps;
  renderItem: (item: any, index: number) => ReactNode;
  CustomRenderItem?: FC<{ children: ReactNode | ((slideData: any) => ReactNode) }>;
}

const CommonCarousel = ({ items, swiperProps, renderItem, CustomRenderItem }: CommonCarouselProps) => {
  const memoizedItems = useMemo(() => items, [items]);
  const memoizedRenderItem = useCallback(renderItem, [renderItem]);

  return (
    <Swiper {...swiperProps}>
      {memoizedItems.map((item, index) => (
        CustomRenderItem
        ? <CustomRenderItem key={`common-carousel-${index}`}>{memoizedRenderItem(item, index)}</CustomRenderItem>
        : <SwiperSlide key={`common-carousel-${index}`}>{memoizedRenderItem(item, index)}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default memo(CommonCarousel);